import { badgesLoading, badgesSuccess, badgesFailure } from 'redux/actions';
import * as badgesSeasonRquests from 'api/requests';
import { addErrorToast } from 'components/Toast/toastService';

export function getTeamBadgesForSeason(teamId: string, seasonId: string) {
	return (dispatch: any) => {
		dispatch(badgesLoading(seasonId));

		return badgesSeasonRquests
			.getTeamSeasonBadges(teamId, seasonId)
			.then(data => {
				dispatch(badgesSuccess(data));
			})
			.catch(error => {
				dispatch(badgesFailure(error));
				addErrorToast(dispatch, 'Oh no! An error occured while retrieving badges for the season.');
			});
	};
}
